// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YgVv","importantInfo":"styles_importantInfo__38y7_"};